export const FETCH_PROFCOUNTRY_ACTION = "FETCH_PROFCOUNTRY_ACTION";
export const FETCH_PROFCOUNTRY_FAIL_ACTION =
  FETCH_PROFCOUNTRY_ACTION + "_ERROR";
export const FETCH_PROFCOUNTRY_SUCCESS_ACTION =
  FETCH_PROFCOUNTRY_ACTION + "_SUCCESS";

export const FETCH_REGION_ACTION = "FETCH_REGION_ACTION";
export const FETCH_REGION_FAIL_ACTION = FETCH_REGION_ACTION + "_ERROR";
export const FETCH_REGION_SUCCESS_ACTION = FETCH_REGION_ACTION + "_SUCCESS";

export const FETCH_LOCATION_ACTION = "FETCH_LOCATION_ACTION";
export const FETCH_LOCATION_FAIL_ACTION = FETCH_LOCATION_ACTION + "_ERROR";
export const FETCH_LOCATION_SUCCESS_ACTION = FETCH_LOCATION_ACTION + "_SUCCESS";

export const FETCH_OPEQUIPMENT_ACTION = "FETCH_OPEQUIPMENT_ACTION";
export const FETCH_OPEQUIPMENT_FAIL_ACTION =
  FETCH_OPEQUIPMENT_ACTION + "_ERROR";
export const FETCH_OPEQUIPMENT_SUCCESS_ACTION =
  FETCH_OPEQUIPMENT_ACTION + "_SUCCESS";

export const FETCH_CARGOTYPE_ACTION = "FETCH_CARGOTYPE_ACTION";
export const FETCH_CARGOTYPE_FAIL_ACTION = FETCH_CARGOTYPE_ACTION + "_ERROR";
export const FETCH_CARGOTYPE_SUCCESS_ACTION =
  FETCH_CARGOTYPE_ACTION + "_SUCCESS";

export const ADD_DRIVERPROFILE_ACTION = "ADD_DRIVERPROFILE_ACTION";
export const ADD_DRIVERPROFILE_FAIL_ACTION =
  ADD_DRIVERPROFILE_ACTION + "_ERROR";
export const ADD_DRIVERPROFILE_SUCCESS_ACTION =
  ADD_DRIVERPROFILE_ACTION + "_SUCCESS";

export const CREATE_DRIVERPROFILE_ACTION = "CREATE_DRIVERPROFILE_ACTION";
export const CREATE_DRIVERPROFILE_FAIL_ACTION =
  CREATE_DRIVERPROFILE_ACTION + "_ERROR";
export const CREATE_DRIVERPROFILE_SUCCESS_ACTION =
  CREATE_DRIVERPROFILE_ACTION + "_SUCCESS";

export const FETCH_DRIVER_IMG_INIT_ACTION = "FETCH_DRIVER_IMG_INIT_ACTION";
export const FETCH_DRIVER_IMG_INIT_ACTION_SUCCESS_ACTION =
  FETCH_DRIVER_IMG_INIT_ACTION + "_SUCCESS";
export const FETCH_DRIVER_IMG_INIT_FAIL_ACTION =
  FETCH_DRIVER_IMG_INIT_ACTION + "_ERROR";

export const FETCH_DRIVER_LICENSEIMG_INIT_ACTION =
  "FETCH_DRIVER_LICENSEIMG_INIT_ACTION";
export const FETCH_DRIVER_LICENSEIMG_SUCCESS_ACTION =
  FETCH_DRIVER_LICENSEIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_DRIVER_LICENSEIMG_FAIL_ACTION =
  FETCH_DRIVER_LICENSEIMG_INIT_ACTION + "_ERROR";

export const FETCH_LICENSEBACKIMG_INIT_ACTION =
  "FETCH_LICENSEBACKIMG_INIT_ACTION";
export const FETCH_LICENSEBACKIMG_SUCCESS_ACTION =
  FETCH_LICENSEBACKIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_LICENSEBACKIMG_FAIL_ACTION =
  FETCH_LICENSEBACKIMG_INIT_ACTION + "_ERROR";

export const FETCH_RESPERMITFRONTIMG_INIT_ACTION =
  "FETCH_RESPERMITFRONTIMG_INIT_ACTION";
export const FETCH_RESPERMITFRONTIMG_SUCCESS_ACTION =
  FETCH_RESPERMITFRONTIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_RESPERMITFRONTIMG_FAIL_ACTION =
  FETCH_RESPERMITFRONTIMG_INIT_ACTION + "_ERROR";

export const FETCH_RESPERMITBACKIMG_INIT_ACTION =
  "FETCH_RESPERMITBACKIMG_INIT_ACTION";
export const FETCH_RESPERMITBACKIMG_SUCCESS_ACTION =
  FETCH_RESPERMITBACKIMG_INIT_ACTION + "_SUCCESS";
export const FETCH_RESPERMITBACKIMG_FAIL_ACTION =
  FETCH_RESPERMITBACKIMG_INIT_ACTION + "_ERROR";

export const EDIT_DRIVERPROFILE_ACTION = "EDIT_DRIVERPROFILE_ACTION";
export const EDIT_DRIVERPROFILE_FAIL_ACTION =
  EDIT_DRIVERPROFILE_ACTION + "_ERROR";
export const EDIT_DRIVERPROFILE_SUCCESS_ACTION =
  EDIT_DRIVERPROFILE_ACTION + "_SUCCESS";

export function fetchCountry() {
  return {
    type: FETCH_PROFCOUNTRY_ACTION,
  };
}
export function fetchregion(params) {
  return {
    type: FETCH_REGION_ACTION,
    params: params,
  };
}
export function fetchlocation(params) {
  return {
    type: FETCH_LOCATION_ACTION,
    params: params,
  };
}
export function fetchopequipment() {
  return {
    type: FETCH_OPEQUIPMENT_ACTION,
  };
}

export function fetchcargotype() {
  return {
    type: FETCH_CARGOTYPE_ACTION,
  };
}
export function adddriverprofile(value) {
  return {
    type: ADD_DRIVERPROFILE_ACTION,
    value: value,
  };
}
export function addDriverImg(value) {
  return {
    type: FETCH_DRIVER_IMG_INIT_ACTION,
    value: value,
  };
}

export function addDriverlicImg(value) {
  return {
    type: FETCH_DRIVER_LICENSEIMG_INIT_ACTION,
    value: value,
  };
}

export function addDriverlicImgBack(value) {
  return {
    type: FETCH_LICENSEBACKIMG_INIT_ACTION,
    value: value,
  };
}

export function addresPermitImg(value) {
  return {
    type: FETCH_RESPERMITFRONTIMG_INIT_ACTION,
    value: value,
  };
}

export function addresPermitBack(value) {
  return {
    type: FETCH_RESPERMITBACKIMG_INIT_ACTION,
    value: value,
  };
}
export function editdriverprofile(value) {
  
  return {
    type: EDIT_DRIVERPROFILE_ACTION,
   
    // id: id,
     value: value,
  };
}